import {ITrackParameter} from "@/types/map";
import {loadModules} from "esri-loader";
import {OverlayArcgis3D} from "../../Overlays/arcgis/OverlayArcgis3D";
import TrackPlayRender from "./TrackPlayRender";

export default class TrackPlay3D {
  private view!: __esri.SceneView;
  private static intances: Map<string, TrackPlay3D>;

  private constructor(view: __esri.SceneView) {
    this.view = view;
  }
  public static getInstance(view: __esri.SceneView) {
    const id = view.container.id;
    if (!TrackPlay3D.intances) {
      TrackPlay3D.intances = new Map();
    }
    let instance = TrackPlay3D.intances.get(id);
    if (!instance) {
      instance = new TrackPlay3D(view);
      TrackPlay3D.intances.set(id, instance);
    }
    return instance;
  }
  public async startTrackPlay(params: ITrackParameter) {
    const [
      webMercatorUtils,
      externalRenderers,
      GraphicsLayer,
      watchUtils,
      promiseUtils
    ] = await loadModules([
      "esri/geometry/support/webMercatorUtils",
      "esri/views/3d/externalRenderers",
      "esri/layers/GraphicsLayer",
      "esri/core/watchUtils",
      "esri/core/promiseUtils"
    ]);
    let allCarTracks: any[] = [];
    let overlays = params.overlays;
    let ovs: any[] = [];
    let colors = [
      [255, 0, 0, 1],
      [0, 0, 255, 1]
    ];
    overlays.forEach((obj: any, num: number) => {
      let graphics: any[] = [];
      let carid = obj.id;
      let flag = Math.floor(Math.random() * 100) % 2 == 0 ? 1 : -1;
      obj.paths.forEach((item: any, index: number) => {
        let x = item[0];
        let y = item[1];
        graphics.push({
          geometry: {x: x, y: y, type: "point"},
          id: obj.id,
          timestamp: 1000 + index * 1000
        });
      });
      ovs.push({
        geometry: {
          paths: [obj.paths]
        },
        fields: {},
        symbol: {
          type: "line",
          color: colors[0]
        }
      });
      allCarTracks.push({id: carid, graphics: graphics});
    });
    // for (let i = 0; i < 100; i++) {}
    console.log(allCarTracks);
    // this.view.goTo(
    //   {
    //     center: [121.412, 31.15],
    //     zoom: 19,
    //     tilt: 75
    //   },
    //   {animate: true, duration: 1000}
    // );

    let points = {
      type: "drawOverlays",
      overlays: ovs
    };
    let a = OverlayArcgis3D.getInstance(this.view);
    const result = await a.addOverlays(points);
    let tp = new TrackPlayRender(this.view, allCarTracks, {});
    externalRenderers.add(this.view, tp);
  }
}
